
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';
export default {
    name: "TutorialSectionBanner",
    mixins: [eventTrackingMixins, lgmMixin],

    props: {
        data: {
            type: Object,
            default: () => ({
            }),
        },
        showBreadcrumb: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            activeItemId: 0,
            title: this.data?.Title,
            subtitle: this.data?.Subtitle,
            checklist: this.data?.Points,
            description: this.data?.Description,
            button1Text: this.data?.Button1Text,
            button1Link: this.data?.Button1Link,
            button2Text: this.data?.Button2Text,
            button2Link: this.data?.Button2Link,
            buttonOtherImage: this.data?.ButtonOtherImage,
            buttonOtherLink: this.data?.ButtonOtherLink,
        };
    },
    computed: {},
    methods: {
        toggleActiveItem(i) {
            if (i === this.activeItemId) {
                this.activeItemId = -1;
            }
            else {
                this.setActiveItem(i);
            }
        },
        setActiveItem(i) {
            this.activeItemId = i;
        },

        
      handleClick(event) {
        event.preventDefault();

        const eventTrackingParams = this.handleEventTracking(event)
        const dataFromClickedElement = this.extractDataFromClickedElement(event.target)

        this.$goToURL(dataFromClickedElement.href, false, eventTrackingParams, {
          getLGMConversionId: this.getLGMConversionId,
          injectLGMConversionId: this.injectLGMConversionId,
          injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
        });

      },
      
      handleEventTracking(event){
        event.preventDefault()
        const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
        const href = dataFromClickedElement.href

        if (this.$isWhatsappLink(href)) {
          const eventTrackingParams = this.initEventTrackingParams()
          eventTrackingParams.a = 'open_whatsapp'
          eventTrackingParams.l =  ``
          eventTrackingParams.c = `guide_cta`
          this.sendEventTracking(eventTrackingParams)
          return eventTrackingParams
        }    

        return null
      },
    },
    // components: { ReusableLink }
}
